import { isNullOrWhiteSpace } from 'owa-string-utils';
import { mutatorAction } from 'satcheljs';
import store from '../store/Store';

/**
 * Action to update the meetingType name in the store.
 */
/* eslint-disable-next-line owa-custom-rules/require-add-identifier-to-mutator-action-variables -- (https://aka.ms/OWALintWiki)
 * Mutator action variables should end with 'Mutator' so that we can more easily identify potential misuses of it.
 *	> Please add 'Mutator' substring add the end of the mutator action variable name. */
export const setMeetingTypeName = mutatorAction(
    'SET_PBP_MEETING_TYPE_NAME',
    (newServiceName: string) => {
        store.meetingTypeEditState.name = newServiceName;
        if (
            store.meetingTypeEditState.needsTitle.hasError &&
            newServiceName.length != 0 &&
            !isNullOrWhiteSpace(newServiceName)
        ) {
            store.meetingTypeEditState.needsTitle.hasError = false;
        }
    }
);
